import { getK1ConsentNudge } from "../services/apiGateway";

export default async function checkK1ConsentNudge() {
  try {
    const abortController = new AbortController();
    const k1ConsentNudgeResponse = await getK1ConsentNudge(
      abortController.signal,
    );
    if (k1ConsentNudgeResponse !== "aborted" && k1ConsentNudgeResponse?.data) {
      return k1ConsentNudgeResponse.data?.isK1ConsentNudgeRequired || false;
    }
    return false;
  } catch (error) {
    console.error("Failed to fetch K1 consent nudge:", error);
    return false;
  }
}
